import React, { useContext } from 'react';
import { Row, Col, Statistic, Card, Icon, Button} from 'antd';
import { StoreContext } from '../containers/Store';
import {
  numberConsecutiveSuccesses,
  meanTimeBetweenAnswers,
  randomAnswers,
  goodAnswers,
  numberExercices
} from '../utils/stats';
import * as ROUTES from '../constants/routes';
import * as ROLES from '../constants/roles';
import paths from '../data/paths';

const { Meta } = Card;

const extractDescription = (pathId) => {
  if (!!paths) {
    if (paths.filter(p =>
        p.path === pathId).length > 0) {
      return paths.filter(p =>
        p.path === pathId)[0].description;
    } else {
      return ""
    }
  } else {
    return ""
  }
}

const DashboardStudent = ({ student }) => {
  let {
    user: {
      user,
    },
    tracking: {
      path: {
        path
      },
      answers: {
        answers
      },
    }
  } = useContext(StoreContext);

  const gotToTest = () => {
    window.location.replace(ROUTES.CHATBOT);
  }

  if (!!user && user.roles.includes(ROLES.TEACHER_DEMO)) {
    path = (localStorage.getItem('evidenceB-token-harry-potter-trackPath')) ?
     JSON.parse(localStorage.getItem('evidenceB-token-harry-potter-trackPath')).path :
     0;
    answers = (localStorage.getItem('evidenceB-token-harry-potter-trackAnswers')) ?
    JSON.parse(localStorage.getItem('evidenceB-token-harry-potter-trackAnswers')).answers :
    [];
  }

  return (
      <div style={window.innerWidth < 520 ? {
        padding: '30px',
      } : {
        padding: '30px',
        height: '80vh',
      }}>
        <Row gutter={16} type="flex" justify="space-around" align="center" style={{ paddingBottom: '16px' }}>
          <Col md={24} xs={24}>
            <Card>
              <Meta
                title="Objectif du parcours"
              />
              <div style={{ paddingTop: "16px"}}>
                { !path &&
                  !!user &&
                  user.roles.includes(ROLES.STUDENT_DEMO) &&
                  <div style={{ padding: "16px"}}>
                    <Button type="primary" onClick={gotToTest}> Passer le test </Button>
                  </div>
                }
                { extractDescription(path) }
              </div>
            </Card>
          </Col>
        </Row>
        <Row gutter={16} type="flex" justify="space-around" align="center" style={{ paddingBottom: '16px' }}>
          <Col md={12} xs={24}>
            <Card>
              {<Statistic
                title="Exercices parcourus"
                value={(!!answers && answers.length > 0) ? numberExercices(answers) : '0'}
              />}
            </Card>
          </Col>
          <Col md={12} xs={24}>
            <Card>
              <Statistic
                title="Temps de réponse moyen"
                value={(!!answers && answers.length > 0) ? meanTimeBetweenAnswers(answers) : '0'}
                precision={0}
                suffix="s."
              />
            </Card>
          </Col>
        </Row>
        <Row gutter={16} type="flex" justify="space-around" align="center" style={{ paddingBottom: '16px' }}>
          <Col md={12} xs={24}>
            <Card> 
              {<Statistic
                title="Taux de bonnes réponses"
                value={(!!answers && answers.length > 0) ? goodAnswers(answers) * 100 / numberExercices(answers) : 'NaN'}
                precision={0}
                suffix="%"
              />}
            </Card>
          </Col>
          <Col md={12} xs={24}>
            <Card>
              <Statistic
                title="Bonnes réponses consécutives"
                value={(!!answers && answers.length > 0) ? numberConsecutiveSuccesses(answers) : '0'}
                prefix={<Icon type="like" />}
              />
            </Card>
          </Col>
        </Row>
        <Row gutter={16} type="flex" justify="space-around" align="center" style={{ paddingBottom: '16px' }}>
          <Col md={12} xs={24}>
            <Card>
              <Statistic
                title="Nombre de bonnes réponses"
                value={(!!answers && answers.length > 0) ? goodAnswers(answers) : '0'}
              />
            </Card>
          </Col>
          <Col md={12} xs={24}>
            <Card>
              <Statistic
                title="Nombre de bonnes réponses quand on répond au hasard"
                value={(!!answers && answers.length > 0) ? randomAnswers(answers) : '0'}
              />
            </Card>
          </Col>
        </Row>
      </div>
    );
};

export default DashboardStudent;